import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'

interface NotFoundProps {
    header: string
    link: string
    translateKey: TranslateKey
}

interface TranslateKey {
    i18nKey: string
    ns: string
}

const NotFound: React.FC<NotFoundProps> = (props: NotFoundProps) => {
    const { t } = useTranslation(props.translateKey.ns);
    return (
        <div className="padding-40 container single">
            <h1><Link to={props.link}>{props.header}</Link></h1>
            <p>
                <Trans t={t} i18nKey={props.translateKey?.i18nKey} ns={props.translateKey?.ns} components={{ lnk: <Link to={props.link}></Link> }} />
            </p>
        </div>
    );
}

export default NotFound;
